import styled from 'styled-components';
import next from '../images/NextBeerButton.svg';
import prev from '../images/PreviousBeerButton.svg';

export default styled.section`
	position: relative;
	.beer-nav {
		position: absolute;
		top: 28vw;
		border-width: 0;
		border-radius: 0;
		background-color: transparent;
		width: 150px;
		height: 75px;
		font-family: ${(p) => p.theme.font.display};
		font-size: 1.25rem;
		transition: transform ease 300ms;
		z-index: 100;
		cursor: pointer;
		&:hover {
			transform: scale(1.1);
		}
		&.next {
			right: 0;
			background-image: url(${next});
			text-align: right;
			padding-right: 4rem;
			&::after {
				content: '>';
				position: absolute;
				top: 0;
				right: 1.5rem;
				line-height: 70px;
				font-size: 1.5rem;
				font-family: ${(p) => p.theme.font.body};
				font-weight: 700;
			}
		}
		&.prev {
			left: 0;
			background-image: url(${prev});
			text-align: left;
			padding-left: 4rem;
			&::after {
				content: '<';
				position: absolute;
				top: 0;
				left: 1.5rem;
				line-height: 70px;
				font-size: 1.5rem;
				font-family: ${(p) => p.theme.font.body};
				font-weight: 700;
			}
		}
		@media (max-width: 999px) {
			top: unset;
			bottom: 3rem;
		}
	}
	.pagebg {
		background-image: url(${(p) => p.mast});
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		min-height: 130vw;
		padding-top: 150px;
		@media (max-width: 1200px) {
			background-position: top center;
			background-size: auto 115%;
		}
		@media (max-width: 999px) {
			background-position: top center;
			background-size: auto 150%;
		}

		.masth {
			height: 42vw;
			@media (max-width: 999px) {
				height: auto;
				margin-bottom: 2rem;
				.is-5 {
					width: unset !important;
				}
			}
			.container {
				height: 100%;
			}
			.opener {
				align-items: center;
				img {
					height: 40vw;
					width: auto;
				}
				@media (max-width: 999px) {
					display: flex;
					flex-direction: column-reverse;
					h1 {
						font-size: 3rem;
						margin-left: 0;
						text-align: center;
					}
					img {
						height: 100vw;
					}
				}
			}
		}

		h1 {
			font-size: 6rem;
			color: ${(p) => (p.invert ? '#fff' : '#000')};
			line-height: 1;
			margin-left: 15vw;
		}

		.beer-single-container {
			position: relative;
			right: 4rem;
			.image-container {
				width: 300px;
				position: absolute;
				top: 0;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}

	.fridge {
		text-align: center;
		max-width: 800px;
		margin: 1rem auto 0 auto;
		h2 {
			font-size: 3rem;
		}

		h3 {
			font-size: 1.5rem;
		}

		p {
			font-size: 1.25rem;
		}
		@media (max-width: 999px) {
			h2 {
				font-size: 2rem;
			}
			p {
				font-size: 1rem;
			}
		}
		.constrain {
			width: 1200px;
			margin: 0 auto;
		}

		.blurb-head {
			color: ${(p) => (p.invert ? '#fff' : '#000')};
		}
		.blurb {
			min-height: 23vw;
			h2 {
				margin-bottom: 0.5rem;
			}
			p {
				font-size: 1.25rem;
			}
			color: ${(p) => (p.invert ? '#fff' : '#000')};
		}

		.split {
			background-color: rgba(0, 0, 0, 0.85);
			color: white;
			text-align: left;
			padding-bottom: 1rem;
			h3 {
				font-size: 2rem;
			}
			p {
				font-size: 1rem;
			}
			.image-container {
				height: 100%;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				img {
					height: 22vw;
					width: auto;
				}
			}
			.deets {
				display: flex;
				align-items: center;
				strong {
					color: white;
				}
				& > div > div {
					margin: 1rem 0;
				}
				.buy-wrap {
					margin-top: 2rem;
					margin-left: -0.5rem;
				}
			}
			@media (max-width: 999px) {
				.hide-mobile {
					display: none;
				}
				.deets > div > div {
					margin: 0;
					padding-bottom: 0;
				}
				margin: 4rem 0;
			}
		}
	}

	.details-section {
		position: relative;
		background-image: url('/img/BeerDetail_BG_Brick.jpg');
		background-size: 100%;
		min-height: 400px;
		color: white;
		padding-top: 5rem;

		.container {
			position: static;
		}

		h2 {
			font-size: 2rem;
			color: ${(p) => p.theme.color.yellow};
		}

		.tap {
			position: absolute;
			bottom: 0;
			width: 100%;
			max-width: 150px;
			@media (max-width: 999px) {
				display: none;
			}
		}

		.constrain {
			display: flex;
			justify-content: flex-start;
		}

		.details {
			max-width: 750px;
			margin: 0 auto;
		}

		.detail {
			display: flex;
			align-items: flex-start;
			margin-bottom: 2rem;

			.icon-wrap {
				flex: 0 0 50px;
				height: 60px;
				img {
					height: 100%;
					width: auto;
				}
				text-align: center;
				margin-right: 2rem;
			}
		}
		@media (max-width: 999px) {
			padding-bottom: 8rem;
		}
	}
`;
